import { CloseCircleOutlined, ExclamationCircleFilled, QuestionCircleTwoTone } from '@ant-design/icons'
import {
  Button,
  Popconfirm,
  TableColumnType,
  Popover,
  Col,
  Space,
  Modal,
} from 'antd'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import {
  selectInsuranceArray,
  selectTenantCategory,
  selectTenantName,
} from '../../app/applicationSlice'
import { StateSwitch } from '../../compnents/widgets/StateSwitch'
import { BillingCategoryName } from '../../models/billingCategory'
import {
  getApproveFlgName,
  getChrgitmLvName,
  getMaterialsName,
  Materials,
} from '../../models/commodity'
import { Dimen } from '../../models/dimen'
import { getOtcCategoryName } from '../../models/Otccategory'
import styles from './Commodity.module.css'
import { Payment } from '../../models/payment'
import { selectMenus } from '../../layouts/layoutSlice'
import { ColDef } from 'ag-grid-community'
import moment from 'moment'

export const Columns = (
  onClick: (text: string, id: any, item?: any) => void,
  startIndex: number,
  queries: any,
  sortedInfo?: any
): TableColumnType<any>[] => {
  const insuranceArray = useSelector(selectInsuranceArray)

  const tenantName = useSelector(selectTenantName)

  const menus = useSelector(selectMenus)

  const tenantCategory = useSelector(selectTenantCategory)

  const flag = menus
    ?.filter((v: any) => v?.name == 'GSP业务')?.[0]
    ?.subMenus?.filter((n: any) => n?.name == '首营管理')?.length
    ? true
    : false
  const colums: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      // fixed: 'left',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    // {
    //   title: "商品名",
    //   align: "center",
    //   fixed: "left",
    //   dataIndex: "name",
    //   width: Dimen.Name,
    //   key: "name",
    //   sorter: (a, b) => a.name.localeCompare(b.name),
    // },
    {
      title: '商品信息',
      // fixed: "left",
      width: '300px',
      ellipsis: true,
      render: function Element(_, record) {
        return (
          <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Col>
              <Popover
                content={
                  <div
                    style={{
                      height: '55px',
                      color:
                        record.count <=
                          (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                          ? 'red'
                          : '',
                    }}
                  >
                    <p
                      style={{
                        height: '28px',
                        lineHeight: '36px',
                        padding: '0',
                        margin: '0',
                        fontSize: '16px',
                        fontWeight: 'bolder',
                      }}
                    >
                      {record.name}
                      {record.count <=
                        (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                        ? '(库存预警)'
                        : ''}
                    </p>
                    <p
                      style={{
                        height: '28px',
                        lineHeight: '24px',
                        padding: '0',
                        margin: '0',
                        color: '#999999',
                        fontSize: '14px',
                      }}
                    >
                      {record.materialsCategory == '0'
                        ? record.packSpec +
                        '/' +
                        record.doseCategory +
                        '/' +
                        record.tenantSupplierName
                        : (record.materialsCategory == '1' || record.materialsCategory == '2')
                          ? record.spec +
                          '/' +
                          record.packSpec +
                          '/' +
                          record.model +
                          '/' +
                          record.tenantSupplierName
                          : record.packSpec +
                          '/' +
                          record.spec +
                          '/' +
                          record.tenantSupplierName}
                    </p>
                  </div>
                }
                placement='bottom'
              >
                <div
                  style={{
                    height: '55px',
                    width: '300px',
                    overflow: 'hidden',
                    color:
                      record.count <=
                        (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                        ? 'red'
                        : '',
                  }}
                >
                  <p
                    style={{
                      height: '28px',
                      lineHeight: '36px',
                      padding: '0',
                      margin: '0',
                      fontSize: '16px',
                      fontWeight: 'bolder',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {record.name}
                    {record.count <=
                      (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                      ? '(库存预警)'
                      : ''}
                  </p>
                  <p
                    style={{
                      height: '28px',
                      lineHeight: '24px',
                      padding: '0',
                      margin: '0',
                      color: '#999999',
                      fontSize: '14px',
                    }}
                  >
                    {record.materialsCategory == '0'
                      ? record.packSpec +
                      '/' +
                      record.doseCategory +
                      '/' +
                      record.tenantSupplierName
                      : (record.materialsCategory == '1' || record.materialsCategory == '2')
                        ? record.spec +
                        '/' +
                        record.packSpec +
                        '/' +
                        record.model +
                        '/' +
                        record.tenantSupplierName
                        : record.packSpec +
                        '/' +
                        record.spec +
                        '/' +
                        record.tenantSupplierName}
                  </p>
                </div>
              </Popover>
            </Col>
          </Space>
        )
      },
      // 商品名/厂家/规格/剂型）name/tenantSupplierName/packSpec/doseCategory
    },
    // {
    //   title: '商品编码',
    //   align: 'center',
    //   dataIndex: 'no',
    //   key: 'no',
    //   width: Dimen.No,
    // },
    {
      title: '通用名',
      align: 'center',
      dataIndex: 'genericName',
      width: '11rem',
      ellipsis: true,
      key: 'nogenericName',
      render: (_, t) => {
        return Number(t.genericName) !== 0 ? t.genericName : ''
      },
    },
    {
      title: '医保国码',
      align: 'center',
      dataIndex: 'hilistCode',
      width: '16rem',
      ellipsis: true,
      className: insuranceArray.length == 0 ? 'notShow' : '',
      key: 'hilistCode',
      render: function Element(_, t) {
        if (t.materialsCategory !== 4) {
          return (
            <div className={t.hilistCode ? styles.delMedicalCode : ''}>
              <div
                className={styles.hilistName}
                onClick={() => {
                  onClick('insurance', t.id, t)
                }}
              >
                {t.hilistCode && <div>{t.hilistName}</div>}
                <div>
                  <Button type='link'>{t.hilistCode || '匹配'}</Button>
                  {getChrgitmLvName(t.chrgitmLv)}
                </div>
              </div>
              {t.hilistCode && (
                <span className={styles.Close}>
                  <CloseCircleOutlined
                    onClick={() => {
                      onClick('delCode', t.id, t)
                    }}
                  />
                </span>
              )}
            </div>
          )
        } else {
          return <></>
        }
      },
      // render: function Element(_, t) {
      //   return (
      //     <Button
      //       type='link'
      //       onClick={() => {
      //         onClick('insurance', t.id, t)
      //       }}
      //     >
      //       查看
      //     </Button>
      //   )
      // },
    },
    {
      title: '医保限价',
      align: 'center',
      width: '7rem',
      ellipsis: true,
      render: function Element(_, t) {
        const xj = Number(t.priceLimit || 0).toFixed(4)
        const isOverLimit = t.isCouldBx !== '0' && Number(xj) > 0 && Number(xj) <= 99998 && Number(xj) < Number(parseFloat(t.retailPrice || 0).toFixed(5));
        return (
          isOverLimit ?
            <Popover
              content={
                <div>
                  <p>
                    零售价超医保限价！
                  </p>
                </div>
              }
              placement='top'
              title='注意'
            >
              <span style={{ color: 'red', fontWeight: "bold" }}>
                {Number(xj) > 0 && Number(xj) <= 99998
                  ? xj
                  : Number(xj) == -1
                    ? '-'
                    : '不限价'}
              </span>
            </Popover>



            :
            <span style={{ color: t.isCouldBx !== '0' ? '#15ad31' : '#000000' }}>
              {Number(xj) > 0 && Number(xj) <= 99998
                ? xj
                : Number(xj) == -1
                  ? '-'
                  : '不限价'}
            </span>
        )
      },
    },
    // {
    //   title: '规格',
    //   align: 'center',
    //   dataIndex: 'packSpec',
    //   width: Dimen.PackSpec,
    //   key: 'packSpec',
    //   render: (_, t) => {
    //     return Number(t.packSpec) !== 0 ? t.packSpec : ''
    //   },
    // },
    // {
    //   title: '单位',
    //   align: 'center',
    //   dataIndex: 'accountUnit',
    //   width: Dimen.Unit,
    //   key: 'accountUnit',
    // },
    {
      title: '批准文号',
      align: 'center',
      dataIndex: 'approvalNumber',
      key: 'approvalNumber',
      width: Dimen.ApprovalNumber,
      ellipsis: true,
    },
    {
      title: '拆零标志',
      align: 'center',
      dataIndex: 'splitTag',
      width: Dimen.State,
      ellipsis: true,
      key: 'splitTag',
      render: (splitTag: number) => {
        return splitTag > 0 ? '是' : '否'
      },
    },
    {
      title: '商品类别',
      align: 'center',
      dataIndex: 'materialsCategory',
      width: Dimen.State,
      render: (_, t) => {
        return getMaterialsName(t.materialsCategory)
      },
    },
    {
      title: '开票项目',
      align: 'center',
      width: Dimen.State,
      dataIndex: 'billingCategory',
      render: (billingCategory: any) => {
        return BillingCategoryName(billingCategory)
      },
    },
    // {
    //   title: '生产厂家',
    //   align: 'center',
    //   dataIndex: 'tenantSupplierName',
    //   key: 'tenantSupplierName',
    // },
    {
      title: '零售价',
      align: 'right',
      dataIndex: 'retailPrice',
      width: Dimen.Category,
      ellipsis: true,
      key: 'retailPrice',
      render: (_, t) => {
        return t.retailPrice
          ? parseFloat(t.retailPrice).toFixed(5)
          : parseFloat('0').toFixed(5)
      },
    },
    {
      title: 'OTC标志',
      align: 'center',
      dataIndex: 'otc',
      width: Dimen.State,
      ellipsis: true,
      render: (_, t) => {
        return BillingCategoryName(t.billingCategory) !== '中草药' &&
          t.materialsCategory == 0
          ? getOtcCategoryName(t.otc)
          : '-'
        // return getOtcCategoryName(t.otc);
      },
    },
    {
      title: '是否国谈药',
      align: 'center',
      dataIndex: 'otc',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.natNegoDrugFlag == 1 ? '是' : '否'
      },
    },
    {
      title: '是否省招',
      align: 'center',
      dataIndex: 'otc',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.provinceTendFlag == 1 ? '是' : '否'
      },
    },
    {
      title: '匹配状态',
      align: 'center',
      dataIndex: 'approveFlg',
      width: '6rem',
      ellipsis: true,
      key: 'approveFlg',
      className: insuranceArray.length == 0 ? 'notShow' : '',
      render: function Element(_, t) {
        return (
          !t.hilistCode ? '未匹配' :
            <Button type={Number(t.approveFlg) ? 'link' : 'text'}>
              {getApproveFlgName(Number(t.approveFlg), t.rewriteHilistCode)}
            </Button>
        )
      },
    },
    {

      title: '创建时间',
      dataIndex: 'createTime',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      key: 'createTime',
      sorter: true,
      sortOrder: sortedInfo?.columnKey === 'createTime' && sortedInfo?.order,
    },
    {
      title: '最近一次修改',
      // fixed: "left",
      align: 'center',
      width: '10rem',
      ellipsis: true,
      key: 'lastUpdateTime',
      sorter: true,
      sortOrder: sortedInfo?.columnKey === 'lastUpdateTime' && sortedInfo?.order,
      render: function Element(_, t) {
        return (
          <a
            onClick={(e) => {
              e.preventDefault()
              if (t?.lastUpdateTime) {
                onClick('lastEditOperation', t?.id, t)
              }
            }}
            style={{ cursor: 'pointer' }}
          >
            {t?.lastUpdateTime}
          </a>
        )
      },
    },
    {
      title: '状态',
      align: 'center',
      dataIndex: 'state',
      width: Dimen.Status,
      render: function Element(_, t) {
        return (
          <div style={{ height: '39px' }}>
            {t.state === 1 ? (
              <Popconfirm
                title={'确认进行注销操作吗？'}
                onConfirm={() => {
                  onClick('setStateForce', t.id)
                }}
                onCancel={() => {
                  onClick('setState', t.id)
                }}
                okText='确认并同步删除套餐/未收费处方'
                //取消按钮当做注销，确认按钮当做强行注销
                cancelButtonProps={{
                  style: {
                    border: 0,
                    backgroundColor: '#027AFF',
                    color: '#FFF',
                  },
                }}
                okButtonProps={{
                  style: {
                    border: 0,
                    backgroundColor: '#fe2121',
                    color: '#FFF',
                  },
                }}
                cancelText='确认'
              >
                <a href='#'>
                  <StateSwitch value={t.state === 1} />
                </a>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={'确认进行启用操作？'}
                onConfirm={() => {
                  onClick('setState', t.id)
                }}
                onCancel={() => {
                  return
                }}
                okText='确认'
                cancelText='取消'
              >
                <a href='#'>
                  <StateSwitch value={t.state === 1} />
                </a>
              </Popconfirm>
            )}




            {/*<Popover*/}
            {/*  content={getPopoverContent(t)}*/}
            {/*  trigger="click"*/}
            {/*  // visible={popoverVisible}*/}
            {/*  // onVisibleChange={setPopoverVisible}*/}
            {/*  placement="top"*/}
            {/*  overlayStyle={{ maxWidth: '300px' }}*/}
            {/*>*/}
            {/*  <a href="#">*/}
            {/*    <StateSwitch value={t.state === 1} />*/}
            {/*  </a>*/}
            {/*</Popover>*/}
          </div>
        )
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '13rem',
      render: function Element(_, t) {
        return (
          <>
            <Button
              type='primary'
              ghost
              size='small'
              style={{ marginRight: '6px' }}
              onClick={() => {
                onClick('edit', t.id, t)
              }}
            >
              编辑
            </Button>
            <Button
              type='primary'
              ghost
              size='small'
              style={{ marginRight: '6px' }}
              onClick={() => {
                Modal.confirm({
                  centered: true,
                  title: '确认操作',
                  content: (
                    <div>
                      <ExclamationCircleFilled
                        style={{ color: '#FFAE55', fontSize: 18 }}
                      />
                      &nbsp;您确定复制目录吗？
                    </div>
                  ),
                  okText: '确认',
                  cancelText: '取消',
                  icon: null,
                  onOk: () => {
                    onClick('copyCatalog', t.id, t)
                  },
                })
              }}
            >
              复制目录
            </Button>
            {flag ? (
              <Button
                type='primary'
                disabled={t?.fsrId > 0 ? true : false}
                size='small'
                style={{ marginRight: '6px' }}
                onClick={() => {
                  onClick('firstBusssiess', t.id, t)
                }}
              >
                首营
              </Button>
            ) : (
              ''
            )}
          </>
        )
      },
    },
  ]
  const result =
    queries?.materialsCategory == '0'
      ? tenantName?.indexOf('余姚健齿口腔诊所有限公司') >= 0 ||
        tenantName?.indexOf('余姚康民内科诊所') >= 0 ||
        tenantName?.indexOf('宁波鄞州青木堂中医诊所') >= 0 ||
        tenantName?.indexOf('宁波鄞州德益内科诊所有限公司') >= 0 ||
        tenantName?.indexOf('宁波鄞州毅康内科诊所有限公司') >= 0
        ? tenantCategory == 17 ? colums.filter((v) => v.key != 'approveFlg' && v.key != 'retailPrice' && v.key != 'lastUpdateTime')
          : colums.filter((v) => v.key != 'approveFlg')
        : tenantCategory == 17 ? colums.filter((v) => v.key != 'retailPrice' && v.key != 'lastUpdateTime')
          : colums
      : tenantName?.indexOf('余姚健齿口腔诊所有限公司') >= 0 ||
        tenantName?.indexOf('余姚康民内科诊所') >= 0 ||
        tenantName?.indexOf('宁波鄞州青木堂中医诊所') >= 0 ||
        tenantName?.indexOf('宁波鄞州德益内科诊所有限公司') >= 0 ||
        tenantName?.indexOf('宁波鄞州毅康内科诊所有限公司') >= 0
        ? tenantCategory == 17 ? colums.filter((v) => v.key != 'nogenericName' && v.key != 'approveFlg' && v.key != 'retailPrice' && v.key != 'lastUpdateTime')
          : colums.filter((v) => v.key != 'nogenericName' && v.key != 'approveFlg')
        : tenantCategory == 17 ? colums.filter((v) => v.key != 'nogenericName' && v.key != 'retailPrice' && v.key != 'lastUpdateTime')
          : colums.filter((v) => v.key != 'nogenericName')
  return result
}
export const Column = (
  onClick: (text: string, id: any, item?: any) => void,
  startIndex: number,
  queries: any,
  sortedInfo?: any
): TableColumnType<any>[] => {
  const insuranceArray = useSelector(selectInsuranceArray)

  const tenantName = useSelector(selectTenantName)

  const menus = useSelector(selectMenus)

  const tenantCategory = useSelector(selectTenantCategory)

  const flag = menus
    ?.filter((v: any) => v?.name == 'GSP业务')?.[0]
    ?.subMenus?.filter((n: any) => n?.name == '首营管理')?.length
    ? true
    : false

  const colums: TableColumnType<any>[] = [
    {
      title: '序号',
      align: 'center',
      // fixed: 'left',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    // {
    //   title: "商品名",
    //   align: "center",
    //   fixed: "left",
    //   dataIndex: "name",
    //   width: Dimen.Name,
    //   key: "name",
    //   sorter: (a, b) => a.name.localeCompare(b.name),
    // },
    {
      title: '商品信息',
      // fixed: "left",
      width: '300px',
      ellipsis: true,
      render: function Element(_, record) {
        return (
          <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Col>
              <Popover
                content={
                  <div
                    style={{
                      height: '55px',
                      color:
                        record.count <=
                          (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                          ? 'red'
                          : '',
                    }}
                  >
                    <p
                      style={{
                        height: '28px',
                        lineHeight: '36px',
                        padding: '0',
                        margin: '0',
                        fontSize: '16px',
                        fontWeight: 'bolder',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {record.name}
                      {record.count <=
                        (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                        ? '(库存预警)'
                        : ''}
                    </p>
                    <p
                      style={{
                        height: '28px',
                        lineHeight: '24px',
                        padding: '0',
                        margin: '0',
                        color: '#999999',
                        fontSize: '14px',
                      }}
                    >
                      {record.materialsCategory == '0'
                        ? record.packSpec +
                        '/' +
                        record.doseCategory +
                        '/' +
                        record.tenantSupplierName
                        : (record.materialsCategory == '1' || record.materialsCategory == '2')
                          ? record.spec +
                          '/' +
                          record.packSpec +
                          '/' +
                          record.model +
                          '/' +
                          record.tenantSupplierName
                          : record.packSpec +
                          '/' +
                          record.spec +
                          '/' +
                          record.tenantSupplierName}
                    </p>
                  </div>
                }
                placement='bottom'
              >
                <div
                  style={{
                    height: '55px',
                    color:
                      record.count <=
                        (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                        ? 'red'
                        : '',
                  }}
                >
                  <p
                    style={{
                      height: '28px',
                      lineHeight: '36px',
                      padding: '0',
                      margin: '0',
                      fontSize: '16px',
                      fontWeight: 'bolder',
                    }}
                  >
                    {record.name}
                    {record.count <=
                      (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                      ? '(库存预警)'
                      : ''}
                  </p>
                  <p
                    style={{
                      height: '28px',
                      lineHeight: '24px',
                      padding: '0',
                      margin: '0',
                      color: '#999999',
                      fontSize: '14px',
                    }}
                  >
                    {record.materialsCategory == '0'
                      ? record.packSpec +
                      '/' +
                      record.doseCategory +
                      '/' +
                      record.tenantSupplierName
                      : (record.materialsCategory == '1' || record.materialsCategory == '2')
                        ? record.spec +
                        '/' +
                        record.packSpec +
                        '/' +
                        record.model +
                        '/' +
                        record.tenantSupplierName
                        : record.packSpec +
                        '/' +
                        record.spec +
                        '/' +
                        record.tenantSupplierName}
                  </p>
                </div>
              </Popover>
            </Col>
          </Space>
        )
      },
      // 商品名/厂家/规格/剂型）name/tenantSupplierName/packSpec/doseCategory
    },
    // {
    //   title: '商品编码',
    //   align: 'center',
    //   dataIndex: 'no',
    //   key: 'no',
    //   width: Dimen.No,
    // },
    {
      title: '通用名',
      align: 'center',
      dataIndex: 'genericName',
      width: Dimen.GenericName,
      key: 'nogenericName',
      render: (_, t) => {
        return Number(t.genericName) !== 0 ? t.genericName : ''
      },
    },
    // {
    //   title: '匹配状态',
    //   align: 'center',
    //   dataIndex: 'approveFlg',
    //   width: Dimen.GenericName,
    //   key: 'approveFlg',
    //   className: insuranceArray.length == 0 ? 'notShow' : '',
    //   render: function Element(_, t) {
    //     return (
    //       <Button type={Number(t.approveFlg) ? 'link' : 'text'}>
    //         {getApproveFlgName(Number(t.approveFlg))}
    //       </Button>
    //     )
    //   },
    // },
    // {
    //   title: '医保国码',
    //   align: 'center',
    //   dataIndex: 'hilistCode',
    //   width: Dimen.ApprovalNumber,
    //   className: insuranceArray.length == 0 ? 'notShow' : '',
    //   key: 'hilistCode',
    //   render: function Element(_, t) {
    //     if (t.materialsCategory !== 4) {
    //       return (
    //         <div className={t.hilistCode ? styles.delMedicalCode : ''}>
    //           <div
    //             className={styles.hilistName}
    //             onClick={() => {
    //               onClick('insurance', t.id, t)
    //             }}
    //           >
    //             {t.hilistCode && <div>{t.hilistName}</div>}
    //             <div>
    //               <Button type='link'>{t.hilistCode || '匹配'}</Button>
    //               {getChrgitmLvName(t.chrgitmLv)}
    //             </div>
    //           </div>
    //           {t.hilistCode && (
    //             <span className={styles.Close}>
    //               <CloseCircleOutlined
    //                 onClick={() => {
    //                   onClick('delCode', t.id, t)
    //                 }}
    //               />
    //             </span>
    //           )}
    //         </div>
    //       )
    //     } else {
    //       return <></>
    //     }
    //   },
    //   // render: function Element(_, t) {
    //   //   return (
    //   //     <Button
    //   //       type='link'
    //   //       onClick={() => {
    //   //         onClick('insurance', t.id, t)
    //   //       }}
    //   //     >
    //   //       查看
    //   //     </Button>
    //   //   )
    //   // },
    // },
    // {
    //   title: '规格',
    //   align: 'center',
    //   dataIndex: 'packSpec',
    //   width: Dimen.PackSpec,
    //   key: 'packSpec',
    //   render: (_, t) => {
    //     return Number(t.packSpec) !== 0 ? t.packSpec : ''
    //   },
    // },
    // {
    //   title: '单位',
    //   align: 'center',
    //   dataIndex: 'accountUnit',
    //   width: Dimen.Unit,
    //   key: 'accountUnit',
    // },
    {
      title: '批准文号',
      align: 'center',
      dataIndex: 'approvalNumber',
      width: Dimen.ApprovalNumber,
      key: 'approvalNumber',
    },
    {
      title: '拆零标志',
      align: 'center',
      dataIndex: 'splitTag',
      width: Dimen.State,
      key: 'splitTag',
      render: (splitTag: number) => {
        return splitTag > 0 ? '是' : '否'
      },
    },
    {
      title: '商品类别',
      align: 'center',
      dataIndex: 'materialsCategory',
      width: Dimen.Category,
      render: (_, t) => {
        return getMaterialsName(t.materialsCategory)
      },
    },
    {
      title: '开票项目',
      align: 'center',
      width: Dimen.BillingCategory,
      dataIndex: 'billingCategory',
      render: (billingCategory: any) => {
        return BillingCategoryName(billingCategory)
      },
    },
    // {
    //   title: '生产厂家',
    //   align: 'center',
    //   dataIndex: 'tenantSupplierName',
    //   key: 'tenantSupplierName',
    // },
    {
      title: '零售价',
      align: 'right',
      dataIndex: 'retailPrice',
      width: Dimen.Price,
      key: 'retailPrice',
      render: (_, t) => {
        return t.retailPrice
          ? parseFloat(t.retailPrice).toFixed(5)
          : parseFloat('0').toFixed(5)
      },
    },
    {
      title: 'OTC标志',
      align: 'center',
      dataIndex: 'otc',
      width: Dimen.State,
      render: (_, t) => {
        return BillingCategoryName(t.billingCategory) !== '中草药' &&
          t.materialsCategory == 0
          ? getOtcCategoryName(t.otc)
          : '-'
        // return getOtcCategoryName(t.otc);
      },
    },
    {
      title: '状态',
      align: 'center',
      dataIndex: 'state',
      width: Dimen.Status,
      render: function Element(_, t) {
        return (
          <div style={{ height: '39px' }}>
            {t.state === 1 ? (
              <Popconfirm
                title={'确认进行注销操作吗？'}
                onConfirm={() => {
                  onClick('setStateForce', t.id)
                }}
                onCancel={() => {
                  onClick('setState', t.id)
                }}
                okText='确认并同步删除套餐/未收费处方'
                //取消按钮当做注销，确认按钮当做强行注销
                cancelButtonProps={{
                  style: {
                    border: 0,
                    backgroundColor: '#027AFF',
                    color: '#FFF',
                  },
                }}
                okButtonProps={{
                  style: {
                    border: 0,
                    backgroundColor: '#fe2121',
                    color: '#FFF',
                  },
                }}
                cancelText='确认'
              >
                <a href='#'>
                  <StateSwitch value={t.state === 1} />
                </a>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={'确认进行启用操作？'}
                onConfirm={() => {
                  onClick('setState', t.id)
                }}
                onCancel={() => {
                  return
                }}
                okText='确认'
                cancelText='取消'
              >
                <a href='#'>
                  <StateSwitch value={t.state === 1} />
                </a>
              </Popconfirm>
            )}




            {/*<Popover*/}
            {/*  content={getPopoverContent(t)}*/}
            {/*  trigger="click"*/}
            {/*  // visible={popoverVisible}*/}
            {/*  // onVisibleChange={setPopoverVisible}*/}
            {/*  placement="top"*/}
            {/*  overlayStyle={{ maxWidth: '300px' }}*/}
            {/*>*/}
            {/*  <a href="#">*/}
            {/*    <StateSwitch value={t.state === 1} />*/}
            {/*  </a>*/}
            {/*</Popover>*/}
          </div>
        )
      },
    },
    {
      title: '创建时间',
      // fixed: "left",
      align: 'center',
      width: '10rem',
      ellipsis: true,
      dataIndex: 'createTime',
      key: 'createTime',
      sorter: true,
      sortOrder: sortedInfo?.columnKey === 'createTime' && sortedInfo?.order,
    },
    {
      title: '最近一次修改',
      // fixed: "left",
      align: 'center',
      width: '10rem',
      ellipsis: true,
      key: 'lastUpdateTime',
      sorter: true,
      sortOrder: sortedInfo?.columnKey === 'lastUpdateTime' && sortedInfo?.order,
      render: function Element(_, t) {
        return (
          <a
            onClick={(e) => {
              e.preventDefault()
              if (t?.lastUpdateTime) {
                onClick('lastEditOperation', t?.id, t)
              }
            }}
            style={{ cursor: 'pointer' }}
          >
            {t?.lastUpdateTime}
          </a>
        )
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '13rem',
      render: function Element(_, t) {
        return (
          <>

            <Button
              type='primary'
              ghost
              size='small'
              style={{ marginRight: '6px' }}
              onClick={() => {
                onClick('edit', t.id, t)
              }}
            >
              编辑
            </Button>
            <Button
              type='primary'
              ghost
              size='small'
              style={{ marginRight: '6px' }}
              onClick={() => {
                Modal.confirm({
                  centered: true,
                  title: '确认操作',
                  content: (
                    <div>
                      <ExclamationCircleFilled
                        style={{ color: '#FFAE55', fontSize: 18 }}
                      />
                      &nbsp;您确定复制目录吗？
                    </div>
                  ),
                  okText: '确认',
                  cancelText: '取消',
                  icon: null,
                  onOk: () => {
                    onClick('copyCatalog', t.id, t)
                  },
                })
              }}
            >
              复制目录
            </Button>
            {flag ?
              <Button
                type='primary'
                size='small'
                disabled={t?.fsrId > 0 ? true : false}
                onClick={() => {
                  onClick('firstBusssiess', t.id, t)
                }}
              >
                首营
              </Button>
              : ''}
          </>
        )
      },
    },
  ]
  const result =
    queries?.materialsCategory == '0'
      ? tenantName?.indexOf('余姚健齿口腔诊所有限公司') >= 0 ||
        tenantName?.indexOf('余姚康民内科诊所') >= 0 ||
        tenantName?.indexOf('宁波鄞州青木堂中医诊所') >= 0 ||
        tenantName?.indexOf('宁波鄞州德益内科诊所有限公司') >= 0 ||
        tenantName?.indexOf('宁波鄞州毅康内科诊所有限公司') >= 0
        ? tenantCategory == 17 ? colums.filter((v) => v.key != 'approveFlg' && v.key != 'retailPrice' && v.key != 'lastUpdateTime')
          : colums.filter((v) => v.key != 'approveFlg')
        : tenantCategory == 17 ? colums.filter((v) => v.key != 'retailPrice' && v.key != 'lastUpdateTime')
          : colums
      : tenantName?.indexOf('余姚健齿口腔诊所有限公司') >= 0 ||
        tenantName?.indexOf('余姚康民内科诊所') >= 0 ||
        tenantName?.indexOf('宁波鄞州青木堂中医诊所') >= 0 ||
        tenantName?.indexOf('宁波鄞州德益内科诊所有限公司') >= 0 ||
        tenantName?.indexOf('宁波鄞州毅康内科诊所有限公司') >= 0
        ? tenantCategory == 17 ? colums.filter((v) => v.key != 'nogenericName' && v.key != 'approveFlg' && v.key != 'retailPrice' && v.key != 'lastUpdateTime')
          : colums.filter((v) => v.key != 'nogenericName' && v.key != 'approveFlg')
        : tenantCategory == 17 ? colums.filter((v) => v.key != 'nogenericName' && v.key != 'retailPrice' && v.key != 'lastUpdateTime')
          : colums.filter((v) => v.key != 'nogenericName')
  return result
}

export const saveDurgColumns = (startIndex: number): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '通用名(商品名)',
      align: 'center',
      dataIndex: 'genericName',
      key: 'genericName',
    },
    {
      title: '规格',
      align: 'center',
      dataIndex: 'packSpec',
      key: 'packSpec',
    },
    {
      title: '商品类型',
      align: 'center',
      dataIndex: 'materialsCategory',
      key: 'materialsCategory',
      render: (_, t) => {
        return getMaterialsName(t.materialsCategory)
      },
    },
    {
      title: '生产厂家',
      align: 'center',
      dataIndex: 'tenantSupplierName',
      key: 'tenantSupplierName',
    },
    {
      title: '零售价',
      align: 'right',
      dataIndex: 'retailPrice',
      key: 'retailPrice',
    },
  ]
}

export const AGColumns = (
  startIndex?: any,
  onClick?: (
    text: string,
    id: any,
    item?: any
  ) => void,
  columnList?: any,
  materialsCategory?: any,
  KFGZZCKLRSJData?: boolean,
): ColDef[] => {
  const menus = useSelector(selectMenus)

  const flag = menus
    ?.filter((v: any) => v?.name == 'GSP业务')?.[0]
    ?.subMenus?.filter((n: any) => n?.name == '首营管理')?.length
    ? true
    : false

  const list = materialsCategory == '0' ? columnList : columnList?.filter((v: any) => v.field != 'genericName')
  return (
    list?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'checkbox':
          return {
            ...item,
            headerClass: styles.checkCenterAligned,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
          };
        case 'index':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) {
                return ''
              }
              return `${Number(startIndex || 0) + params.node.rowIndex + 1}`
            },
          };
        // 商品信息
        case 'name':
          return {
            ...item,
            cellStyle: { textAlign: 'left' },
            headerClass: styles.leftAligned,
            cellRendererFramework: function getpatientName(params: any) {
              const record = params.data;
              if (params.node.rowPinned) {
                return ''
              }
              return (
                <div className={styles.cellLeft}>
                  <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Col>
                      <Popover
                        content={
                          <div
                            style={{
                              height: '55px',
                              color:
                                record.count <=
                                  (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                                  ? 'red'
                                  : '',
                            }}
                          >
                            <p
                              style={{
                                height: '28px',
                                lineHeight: '36px',
                                padding: '0',
                                margin: '0',
                                fontSize: '16px',
                                fontWeight: 'bolder',
                              }}
                            >
                              {record.name}
                              {record.count <=
                                (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                                ? '(库存预警)'
                                : ''}
                            </p>
                            <p
                              style={{
                                height: '28px',
                                lineHeight: '24px',
                                padding: '0',
                                margin: '0',
                                color: '#999999',
                                fontSize: '14px',
                              }}
                            >
                              {record.materialsCategory == '0'
                                ? record.packSpec +
                                '/' +
                                record.doseCategory +
                                '/' +
                                record.tenantSupplierName
                                : (record.materialsCategory == '1' || record.materialsCategory == '2')
                                  ? record.spec +
                                  '/' +
                                  record.packSpec +
                                  '/' +
                                  record.model +
                                  '/' +
                                  record.tenantSupplierName
                                  : record.packSpec +
                                  '/' +
                                  record.spec +
                                  '/' +
                                  record.tenantSupplierName}
                            </p>
                          </div>
                        }
                        placement='bottom'
                      >
                        <div
                          style={{
                            height: '55px',
                            width: '300px',
                            overflow: 'hidden',
                            padding: ' 0 16px',
                            color:
                              record.count <=
                                (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                                ? 'red'
                                : '',
                          }}
                        >
                          <p
                            style={{
                              height: '28px',
                              lineHeight: '36px',
                              padding: '0',
                              margin: '0',
                              fontSize: '16px',
                              fontWeight: 'bolder',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {record.name}
                            {record.count <=
                              (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                              ? '(库存预警)'
                              : ''}
                          </p>
                          <p
                            style={{
                              height: '28px',
                              lineHeight: '24px',
                              padding: '0',
                              margin: '0',
                              color: '#999999',
                              fontSize: '14px',
                            }}
                          >
                            {record.materialsCategory == '0'
                              ? record.packSpec +
                              '/' +
                              record.doseCategory +
                              '/' +
                              record.tenantSupplierName
                              : (record.materialsCategory == '1' || record.materialsCategory == '2')
                                ? record.spec +
                                '/' +
                                record.packSpec +
                                '/' +
                                record.model +
                                '/' +
                                record.tenantSupplierName
                                : record.packSpec +
                                '/' +
                                record.spec +
                                '/' +
                                record.tenantSupplierName}
                          </p>
                        </div>
                      </Popover>
                    </Col>
                  </Space>
                </div>
              );
            },
          };
        // 通用名
        case 'genericName':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return Number(t.genericName) !== 0 ? t.genericName : '-'
            },
          };
        case 'origin':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.origin ? t?.origin : '-'
            },
          };
        // 医保国码
        case 'hilistCode':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
            cellRendererFramework: function getStarName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t.materialsCategory !== 4 ?
                <div className={t.hilistCode ? styles.delMedicalCode : ''}>
                  <div
                    className={styles.hilistName}
                    onClick={() => {
                      onClick && onClick('insurance', t.id, t)
                    }}
                  >
                    {t.hilistCode && <div>{t?.hilistName}</div>}
                    <div>
                      <Button type='link'>{t?.hilistCode || '匹配'}</Button>
                      {getChrgitmLvName(t?.chrgitmLv)}
                    </div>
                  </div>
                  {t.hilistCode && (
                    <span className={styles.Close}>
                      <CloseCircleOutlined
                        onClick={() => {
                          onClick && onClick('delCode', t.id, t)
                        }}
                      />
                    </span>
                  )}
                </div> : <></>
            },
          };
        // 医保限价
        case 'priceLimit':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
            cellRendererFramework: function getStarName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const xj = Number(t?.priceLimit || 0).toFixed(4)
              const isOverLimit = t?.isCouldBx !== '0' && Number(xj) > 0 && Number(xj) <= 99998 && Number(xj) < Number(parseFloat(t?.retailPrice || 0).toFixed(5));
              return (
                isOverLimit ?
                  <Popover
                    content={
                      <div>
                        <p>
                          零售价超医保限价！
                        </p>
                      </div>
                    }
                    placement='top'
                    title='注意'
                  >
                    <span style={{ color: 'red', fontWeight: "bold" }}>
                      {Number(xj) > 0 && Number(xj) <= 99998
                        ? xj
                        : Number(xj) == -1
                          ? '-'
                          : '不限价'}
                    </span>
                  </Popover>
                  :
                  <span style={{ color: t?.isCouldBx !== '0' ? '#15ad31' : '#000000' }}>
                    {Number(xj) > 0 && Number(xj) <= 99998
                      ? xj
                      : Number(xj) == -1
                        ? '-'
                        : '不限价'}
                  </span>
              )
            },
          };
        //  批准文号
        case 'approvalNumber':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.approvalNumber || '-';
            },
          };
        // 拆零标志
        case 'splitTag':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.splitTag > 0 ? '是' : '否'
            },
          };
        // 商品类别
        case 'materialsCategory':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return getMaterialsName(t?.materialsCategory) || '-';
            },
          };
        // 开票项目
        case 'billingCategory':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return BillingCategoryName(t?.billingCategory) || '-';
            },
          };
        // 零售价
        case 'retailPrice':
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'right', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t.retailPrice
                ? parseFloat(t?.retailPrice).toFixed(5)
                : parseFloat('0').toFixed(5)
            },
          };
        // 进价
        case 'unitPrice':
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'right', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return !KFGZZCKLRSJData ? '***' : t.unitPrice == -1 ? '-' : t.unitPrice
                ? parseFloat(t?.unitPrice).toFixed(5)
                : parseFloat('0').toFixed(5)
            },
          };
        // OTC标志
        case 'otc':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return (BillingCategoryName(t?.billingCategory) != '中草药' &&
                t.materialsCategory == 0)
                ? getOtcCategoryName(t?.otc) || '-'
                : '-'
            },
          };
        // 是否国谈药
        case 'natNegoDrugFlag':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.natNegoDrugFlag == 1 ? '是' : '否'
            },
          };
        // 是否省招
        case 'provinceTendFlag':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t.provinceTendFlag == 1 ? '是' : '否'
            },
          };
        // 包装材质
        case 'pacmatl':
          return {
              ...item,
              cellStyle: { textAlign: 'center', lineHeight: '56px' },
              cellRendererFramework: (params: any) => {
                  if (params.node.rowPinned) return '';
                  const t = params.data;
                  return t?.pacmatl || '-';
              },
          };
        // 税率
        case 'tax':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.taxStr != null && t?.taxStr !== '' ? t?.tax : '-'
            },
          };
        // 匹配状态
        case 'approveFlg':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: function getApproveFlg(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return (!t.hilistCode ? '未匹配' :
                <Button type={Number(t?.approveFlg) ? 'link' : 'text'}>
                  {getApproveFlgName(Number(t?.approveFlg), t?.rewriteHilistCode)}
                </Button>)
            },
          };
        // 创建时间
        case 'createTime':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.createTime ? t?.createTime : '-';
            },
          };
        //   // 最近一次修改
        case 'lastUpdateTime':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: function getLastUpdate(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data
              return (
                <a onClick={((e) => {
                  e.preventDefault()
                  if (t?.lastUpdateTime) {
                    onClick && onClick('lastEditOperation', t?.id, t)
                  }
                })}>
                  {t?.lastUpdateTime}
                </a>)
            },
          };
        // 状态
        case 'state':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: function getState(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data
              return (
                <div style={{ height: '39px' }}>
                  {t.state === 1 ? (
                    <Popconfirm
                      title={'确认进行注销操作吗？'}
                      onConfirm={() => {
                        onClick && onClick('setStateForce', t.id)
                      }}
                      onCancel={() => {
                        onClick && onClick('setState', t.id)
                      }}
                      okText='确认并同步删除套餐/未收费处方'
                      //取消按钮当做注销，确认按钮当做强行注销
                      cancelButtonProps={{
                        style: {
                          border: 0,
                          backgroundColor: '#027AFF',
                          color: '#FFF',
                        },
                      }}
                      okButtonProps={{
                        style: {
                          border: 0,
                          backgroundColor: '#fe2121',
                          color: '#FFF',
                        },
                      }}
                      cancelText='确认'
                    >
                      <a href='#'>
                        <StateSwitch value={t.state === 1} />
                      </a>
                    </Popconfirm>
                  ) : (
                    <Popconfirm
                      title={'确认进行启用操作？'}
                      onConfirm={() => {
                        onClick && onClick('setState', t.id)
                      }}
                      onCancel={() => {
                        return
                      }}
                      okText='确认'
                      cancelText='取消'
                    >
                      <a href='#'>
                        <StateSwitch value={t.state === 1} />
                      </a>
                    </Popconfirm>
                  )}
                </div>)
            },
          };
        case 'action':
          return {
            ...item,
            cellStyle: { textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' },
            cellRendererFramework: function getActionName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              // 确保只在合适的状态下显示退费按钮，避免重复显示
              return (
                <>
                  <Button
                    type='primary'
                    ghost
                    size='small'
                    style={{ marginRight: '6px' }}
                    onClick={() => {
                      onClick && onClick('edit', t.id, t)
                    }}
                  >
                    编辑
                  </Button>
                  <Button
                    type='primary'
                    ghost
                    size='small'
                    style={{ marginRight: '6px' }}
                    onClick={() => {
                      Modal.confirm({
                        centered: true,
                        title: '确认操作',
                        content: (
                          <div>
                            <ExclamationCircleFilled
                              style={{ color: '#FFAE55', fontSize: 18 }}
                            />
                            &nbsp;您确定复制目录吗？
                          </div>
                        ),
                        okText: '确认',
                        cancelText: '取消',
                        icon: null,
                        onOk: () => {
                          onClick && onClick('copyCatalog', t.id, t)
                        },
                      })
                    }}
                  >
                    复制目录
                  </Button>
                  {flag ? (
                    <Button
                      type='primary'
                      disabled={t?.fsrId > 0 ? true : false}
                      size='small'
                      style={{ marginRight: '6px' }}
                      onClick={() => {
                        onClick && onClick('firstBusssiess', t.id, t)
                      }}
                    >
                      首营
                    </Button>
                  ) : (
                    ''
                  )}
                </>
              )
            }
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
          };
      }
    })
  )
}

export const YJTBXJDSJAGColumns = (
  startIndex?: any,
  columnList?: any,
  flag?: number,
): ColDef[] => {

  console.log(columnList, "allColumnListallColumnList")
  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'checkbox':
          return {
            ...item,
            headerClass: styles.checkCenterAligned,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
          };
        // 商品信息
        case 'name':
          return {
            ...item,
            cellStyle: { textAlign: 'left' },
            headerClass: styles.leftAligned,
            cellRendererFramework: function getpatientName(params: any) {
              const record = params.data;
              if (params.node.rowPinned) {
                return ''
              }
              return (
                <div>
                  {flag == 1 ?
                    <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Col>
                        <Popover
                          content={
                            <div
                              style={{
                                height: '55px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <p
                                style={{
                                  padding: '0',
                                  margin: '0',
                                  fontSize: '16px',
                                  fontWeight: 'bolder',
                                }}
                              >
                                {record.name}
                              </p>
                            </div>
                          }
                          placement='bottom'
                        >
                          <div
                            style={{
                              height: '55px',
                              display: 'flex',
                              fontSize: '16px',
                              alignItems: 'center',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              fontWeight: 'bolder',
                            }}
                          >
                            {record.name}
                          </div>
                        </Popover>
                      </Col>
                    </Space> :
                    <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Col>
                        <Popover
                          content={
                            <div
                              style={{
                                height: '55px',
                                color:
                                  record.count <=
                                    (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                                    ? 'red'
                                    : '',
                              }}
                            >
                              <p
                                style={{
                                  height: '28px',
                                  lineHeight: '36px',
                                  padding: '0',
                                  margin: '0',
                                  fontSize: '16px',
                                  fontWeight: 'bolder',
                                }}
                              >
                                {record.name}
                                {record.count <=
                                  (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                                  ? '(库存预警)'
                                  : ''}
                              </p>
                              <p
                                style={{
                                  height: '28px',
                                  lineHeight: '24px',
                                  padding: '0',
                                  margin: '0',
                                  color: '#999999',
                                  fontSize: '14px',
                                }}
                              >
                                {record.materialsCategory == '0'
                                  ? record.packSpec +
                                  '/' +
                                  record.doseCategory +
                                  '/' +
                                  record.tenantSupplierName
                                  : (record.materialsCategory == '1' || record.materialsCategory == '2')
                                    ? record.spec +
                                    '/' +
                                    record.packSpec +
                                    '/' +
                                    record.model +
                                    '/' +
                                    record.tenantSupplierName
                                    : record.packSpec +
                                    '/' +
                                    record.spec +
                                    '/' +
                                    record.tenantSupplierName}
                              </p>
                            </div>
                          }
                          placement='bottom'
                        >
                          <div
                            style={{
                              height: '55px',
                              overflow: 'hidden',
                              padding: '0 16px 0 0 ',
                              color:
                                record.count <=
                                  (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                                  ? 'red'
                                  : '',
                            }}
                          >
                            <p
                              style={{
                                height: '28px',
                                lineHeight: '36px',
                                padding: '0',
                                margin: '0',
                                fontSize: '16px',
                                fontWeight: 'bolder',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {record.name}
                              {record.count <=
                                (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
                                ? '(库存预警)'
                                : ''}
                            </p>
                            <p
                              style={{
                                height: '28px',
                                lineHeight: '24px',
                                padding: '0',
                                margin: '0',
                                color: '#999999',
                                fontSize: '14px',
                              }}
                            >
                              {record.materialsCategory == '0'
                                ? record.packSpec +
                                '/' +
                                record.doseCategory +
                                '/' +
                                record.tenantSupplierName
                                : (record.materialsCategory == '1' || record.materialsCategory == '2')
                                  ? record.spec +
                                  '/' +
                                  record.packSpec +
                                  '/' +
                                  record.model +
                                  '/' +
                                  record.tenantSupplierName
                                  : record.packSpec +
                                  '/' +
                                  record.spec +
                                  '/' +
                                  record.tenantSupplierName}
                            </p>
                          </div>
                        </Popover>
                      </Col>
                    </Space>}
                </div>
              );
            },
          };
        // 医保国码
        case 'hilistCode':
          return {
            ...item,
            headerClass: styles.leftAligned,
            cellStyle: { textAlign: 'left', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' },
            cellRendererFramework: function getStarName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t.materialsCategory !== 4 ?
                <div className={t.hilistCode ? styles.delMedicalCodes : ''}>
                  <div
                    className={styles.hilistNameAG}
                  >
                    {t.hilistCode && <div>{t?.hilistName}</div>}
                    <div>
                      <Button type='link' style={{ padding: '4px 6px 4px 0px' }}>{t?.hilistCode || '匹配'}</Button>
                      {getChrgitmLvName(t?.chrgitmLv)}
                    </div>
                  </div>
                </div> : <></>
            },
          };
        // 医保限价
        case 'priceLimit':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
            cellRendererFramework: function getStarName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const xj = Number(t?.priceLimit || 0).toFixed(4)
              const isOverLimit = t?.isCouldBx !== '0' && Number(xj) > 0 && Number(xj) <= 99998 && Number(xj) < Number(parseFloat(t?.retailPrice || 0).toFixed(5));
              return (
                isOverLimit ?
                  <Popover
                    content={
                      <div>
                        <p>
                          零售价超医保限价！
                        </p>
                      </div>
                    }
                    placement='top'
                    title='注意'
                  >
                    <span style={{ color: 'red', fontWeight: "bold" }}>
                      {Number(xj) > 0 && Number(xj) <= 99998
                        ? xj
                        : Number(xj) == -1
                          ? '-'
                          : '不限价'}
                    </span>
                  </Popover>
                  :
                  <span style={{ color: t?.isCouldBx !== '0' ? '#15ad31' : '#000000' }}>
                    {Number(xj) > 0 && Number(xj) <= 99998
                      ? xj
                      : Number(xj) == -1
                        ? '-'
                        : '不限价'}
                  </span>
              )
            },
          };
        // 目录售价
        case 'retailPrice':
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'right', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t.retailPrice
                ? parseFloat(t?.retailPrice).toFixed(5)
                : parseFloat('0').toFixed(5)
            },
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
          };
      }
    })
  )
}


export const YJTBXJDKCAGColumns = (
  startIndex?: any,
  columnList?: any,
): ColDef[] => {

  console.log(columnList, "allColumnListallColumnList")
  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'checkbox':
          return {
            ...item,
            headerClass: styles.checkCenterAligned,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
          };
        case 'name': // 商品信息
          return {
            ...item,
            cellStyle: { textAlign: 'left' },
            headerClass: styles.leftAligned,
            cellRendererFramework: function getName(params: any) {
              if (params.node.rowPinned) {
                return '合计'
              }
              const record = params.data;
              const deadline = moment(record?.deadline)
              const duration = moment.duration(deadline?.diff(moment()))
              const days = duration.asDays()
              if (record?.name == '') {
                return ''
              } else {
                return (
                  <>
                    <Space
                      style={{ display: 'flex', justifyContent: 'space-between' }}
                    >
                      <Col>
                        <Popover
                          content={
                            <>
                              <div
                                style={{
                                  height: '55px',
                                  color:
                                    record?.inventoryAlert &&
                                      record?.inventoryAlert > 0 &&
                                      record?.count < record?.inventoryAlert
                                      ? 'red'
                                      : '',
                                }}
                              >
                                <p
                                  title={
                                    record?.name +
                                    ' 在库存小于 ' +
                                    record?.inventoryAlert +
                                    record?.accountUnit +
                                    ' 时预警'
                                  }
                                  style={{
                                    height: '28px',
                                    lineHeight: '36px',
                                    padding: '0',
                                    margin: '0',
                                    fontSize: '16px',
                                    fontWeight: 'bolder',
                                    color:
                                      days > 180 || record?.mergeFlag
                                        ? '#333333'
                                        : days > 90
                                          ? '#027AFF'
                                          : days > 30
                                            ? '#FA8714'
                                            : days > 0
                                              ? 'red'
                                              : '#9564ad',
                                  }}
                                >
                                  {record?.inventoryAlert &&
                                    record?.inventoryAlert > 0 &&
                                    record?.count < record?.inventoryAlert ? (
                                    <span style={{ color: 'red' }}>
                                      {record?.name}
                                    </span>
                                  ) : (
                                    <span>{record?.name}</span>
                                  )}

                                  {record?.inventoryAlert &&
                                    record?.inventoryAlert > 0 &&
                                    record?.count < record?.inventoryAlert ? (
                                    <span style={{ color: 'red' }}>
                                      {' （不足' +
                                        record?.inventoryAlert +
                                        record?.accountUnit +
                                        '）'}
                                    </span>
                                  ) : (
                                    ''
                                  )}
                                </p>
                                <p
                                  style={{
                                    height: '28px',
                                    lineHeight: '24px',
                                    padding: '0',
                                    margin: '0',
                                    color:
                                      days > 180 || record?.mergeFlag
                                        ? '#999999'
                                        : days > 90
                                          ? '#027AFF'
                                          : days > 30
                                            ? '#FA8714'
                                            : days > 0
                                              ? 'red'
                                              : '#9564ad',
                                    fontSize: '14px',
                                  }}
                                >
                                  {record?.materialsCategory == '1' || record?.materialsCategory == '2' ?
                                    record?.tenantSupplierName + '/' + record?.spec + '/' + record?.packSpec + '/' + record?.model
                                    : record?.tenantSupplierName + '/' + record?.spec + '/' + record?.packSpec + '/' + record?.doseCategory}
                                </p>
                              </div>
                            </>
                          }
                          placement='bottom'
                        >
                          <div
                            style={{
                              height: '55px',
                              color:
                                record?.inventoryAlert &&
                                  record?.inventoryAlert > 0 &&
                                  record?.count < record?.inventoryAlert
                                  ? 'red'
                                  : '',
                            }}
                          >
                            <p
                              title={
                                record?.name +
                                ' 在库存小于 ' +
                                record?.inventoryAlert +
                                record?.accountUnit +
                                ' 时预警'
                              }
                              style={{
                                height: '28px',
                                lineHeight: '36px',
                                padding: '0',
                                margin: '0',
                                fontSize: '16px',
                                fontWeight: 'bolder',
                                color:
                                  days > 180 || record?.mergeFlag
                                    ? '#333333'
                                    : days > 90
                                      ? '#027AFF'
                                      : days > 30
                                        ? '#FA8714'
                                        : days > 0
                                          ? 'red'
                                          : '#9564ad',
                              }}
                            >
                              {record?.inventoryAlert &&
                                record?.inventoryAlert > 0 &&
                                record?.count < record?.inventoryAlert ? (
                                <span style={{ color: 'red' }}>{record.name}</span>
                              ) : (
                                <span>{record.name}</span>
                              )}

                              {record?.inventoryAlert &&
                                record?.inventoryAlert > 0 &&
                                record?.count < record?.inventoryAlert ? (
                                <span style={{ color: 'red' }}>
                                  {' （不足' +
                                    record?.inventoryAlert +
                                    record?.accountUnit +
                                    '）'}
                                </span>
                              ) : (
                                ''
                              )}
                            </p>
                            <p
                              style={{
                                height: '28px',
                                lineHeight: '24px',
                                padding: '0',
                                margin: '0',
                                color:
                                  days > 180 || record?.mergeFlag
                                    ? '#999999'
                                    : days > 90
                                      ? '#027AFF'
                                      : days > 30
                                        ? '#FA8714'
                                        : days > 0
                                          ? 'red'
                                          : '#9564ad',
                                fontSize: '14px',
                              }}
                            >
                              {record?.materialsCategory == '1' || record?.materialsCategory == '2' ?
                                record?.tenantSupplierName + '/' + record?.spec + '/' + record?.packSpec + '/' + record?.model
                                : record?.tenantSupplierName + '/' + record?.spec + '/' + record?.packSpec + '/' + record?.doseCategory}
                            </p>
                          </div>
                        </Popover>
                      </Col>
                    </Space>
                  </>
                )
              }
            },
          };
        case 'storehouseName':// 所属库房
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: function getNames(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field]
              const deadline = moment(t?.deadline)
              const duration = moment.duration(deadline?.diff(moment()))
              const days = duration?.asDays()
              return (
                <div style={{
                  color:
                    days > 180 || t.mergeFlag
                      ? '#333333'
                      : days > 90
                        ? '#027AFF'
                        : days > 30
                          ? '#FA8714'
                          : days > 0
                            ? 'red'
                            : '#9564ad',
                }}>
                  {t.mergeFlag ? '-' : val || '-'}
                </div>)
            },
          };
        case 'batchNo':  // 批次号
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: function getNames(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field]
              const deadline = moment(t?.deadline)
              const duration = moment.duration(deadline?.diff(moment()))
              const days = duration?.asDays()
              return (
                <div style={{
                  color:
                    days > 180 || t.mergeFlag
                      ? '#333333'
                      : days > 90
                        ? '#027AFF'
                        : days > 30
                          ? '#FA8714'
                          : days > 0
                            ? 'red'
                            : '#9564ad',
                }}>
                  {t.mergeFlag ? '-' : val}
                </div>)
            },
          };
        case 'catalogRetailPrice': // 目录售价
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'right', lineHeight: '56px' },
            cellRendererFramework: function getRetailPrice(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const deadline = moment(t?.deadline)
              const duration = moment.duration(deadline?.diff(moment()))
              const days = duration?.asDays()
              return (
                <div
                  style={{
                    color:
                      days > 180 || t.mergeFlag
                        ? '#333333'
                        : days > 90
                          ? '#027AFF'
                          : days > 30
                            ? '#FA8714'
                            : days > 0
                              ? 'red'
                              : '#9564ad',
                  }}
                >
                  {t.mergeFlag
                    ? t.retailPriceInterval
                    : parseFloat(t.catalogRetailPrice).toFixed(5)}
                </div>
              )
            },
          };
        case 'retailPrice': // 库存售价
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'right', lineHeight: '56px' },
            cellRendererFramework: function getPriceTotal(params: any) {
              const t = params.data;
              const field = item.field;
              const val = Number(t?.[field])
              const deadline = moment(t.deadline)
              const duration = moment.duration(deadline.diff(moment()))
              const days = duration.asDays()
              return (
                <div
                  style={{
                    color:
                      days > 180 || t.mergeFlag
                        ? '#333333'
                        : days > 90
                          ? '#027AFF'
                          : days > 30
                            ? '#FA8714'
                            : days > 0
                              ? 'red'
                              : '#9564ad',
                  }}
                >
                  {t.mergeFlag
                    ? t.retailPriceInterval
                    : parseFloat(t.retailPrice).toFixed(5)}
                </div>
              )
            },
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
          };
      }
    })
  )
}

